export default "__VITE_ASSET__26ecef46__"